
export function generateTextOutline(
    radius = 8,
    steps = 64,
    color = "#09246f"
) {
    return Array.from({ length: steps }, (_, i) => {
        const angle = (2 * Math.PI * i) / steps;

        const x = (Math.cos(angle) * radius).toFixed(2);
        const y = (Math.sin(angle) * radius).toFixed(2);

        return `${x}px ${y}px 0 ${color}`;
    }).join(", ");
}
